export const enum BankATMScreen {
  Home = "Home",
  Withdraw = "Withdraw",
  Deposit = "Deposit",
  Transfer = "Transfer",
  PhoneTopUp = "PhoneTopUp",
}
